import { SearchIcon } from 'primitives/icons'
import { Link } from '@repo/web-ui/components/link'

export interface SearchInputProps extends PropsWithOptionalChildren<
  React.InputHTMLAttributes<HTMLInputElement>
> {
  href?: string
  handleAnchorClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
  handleSearch?: () => void
}

export function SearchInput({
  value,
  href,
  placeholder = '',
  onChange,
  onKeyDown,
  onFocus,
  onBlur,
  handleAnchorClick,
  handleSearch,
  ...inputProps
}: SearchInputProps) {
  return (
    <div className="relative flex w-full items-center">
      <input
        name="search"
        value={value}
        onChange={onChange}
        className="placeholder-transition text-14 w-full border border-[#FFFFFF] bg-white px-5 py-[10px] pr-10 text-[#261D35] shadow-[0px_5px_15px_0px_#0000001A] placeholder:text-[#9F9CAB] focus:outline-none"
        type="text"
        placeholder={placeholder}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        onBlur={onBlur}
        {...inputProps}
      />
      {href ? (
        <Link
          color="inherit"
          href={href}
          onClick={handleAnchorClick}
          className="absolute inset-y-0 right-0 flex items-center pr-3"
        >
          <SearchIcon aria-label="search" className="h-[18px] w-[18px] text-[#9F9CAB]" />
        </Link>
      ) : (
        <div
          onClick={handleSearch}
          className="absolute inset-y-0 right-0 flex cursor-pointer items-center pr-3"
        >
          <SearchIcon aria-label="search" className="h-[18px] w-[18px] text-[#9F9CAB]" />
        </div>
      )}
    </div>
  )
}
